export const LOGIN = "LOGIN";
export const STATE = "STATE";
export const CITY = "CITY";
export const PROFILE_INFO = "PROFILE_INFO"
export const SET_PROFILE = "SET_PROFILE"
export const GET_SLIDER = "GET_SLIDER"
export const GET_APP = "GET_APP"
export const ADD_TICKET = "ADD_TICKET"
export const GET_TICKET = "GET_TICKET"
export const SET_TOKEN = "SET_TOKEN"
export const LOGOUT = "LOGOUT"
export const GET_WALLET = "GET_WALLET"

export const GET_COUNT = "GET_COUNT"
export const GET_INIT_ORDER = "GET_INIT_ORDER"
export const SET_PUSH_TOK = "SET_PUSH_TOK"


import config from "../../constants/config"
import axios from "axios"
import FormData from "form-data"



// export const setquantity = (data) => {
//     return async (dispatch) => {
//       dispatch({ type: SET_QUN, data});
//     };
//   };



// export const setproducting = (data) => {
//     return async (dispatch) => {
//       dispatch({ type: SET_PRO, data});
//     };
//   };


export const setAccessToken = (token) => {
    return async (dispatch) => {
        dispatch({ type: SET_TOKEN, data: token });
    };
};


export const logOut = () => {
    return async (dispatch) => {
        dispatch({ type: LOGOUT });
    };
};



export const getCount = (access_token) => {
    return async (dispatch) => {

        let Header = {
            Accept: "application/json",
            Authorization: "Bearer " + access_token,
        };
        const url = "https://npln.ir/api/v1/order/count-open-orders";
        return axios({
            method: "get",
            url: url,
            headers: Header,
            
        })

            .then(function (response) {
                //console.log(response);
                const resData = response;
                const data = resData.data;
                //console.log(data);
                dispatch({ type: GET_COUNT, data });
                return response;
            })
            .catch(function (error) {
                console.log(error.name);
                console.log(error.message);
                console.log(error);



            });
    };
};




export const getInitOrder = (access_token,ids) => {
    return async (dispatch) => {

        let Header = {
            Accept: "application/json",
            Authorization: "Bearer " + access_token,
        };
        console.log(ids);
        const url = "https://npln.ir/api/v1/order/init-order?category_id=" + ids;
        return axios({
            method: "get",
            url: url,
            headers: Header,
            
        })

            .then(function (response) {
               console.log(response);
                const resData = response;
                const data = resData.data;
                //console.log(data);
                dispatch({ type: GET_INIT_ORDER, data });
                return response;
            })
            .catch(function (error) {
                console.log(error.name);
                console.log(error.message);
                console.log(error);



            });
    };
};




export const sendtokenPush = (access_token,tokpush) => {
    return async (dispatch) => {
        const Header = {
            Accept: "application/json",
            Authorization: "Bearer " + access_token,
        }

        var formdata = new FormData();
        formdata.append("device_token", tokpush);

        var requestOptions = {
            method: 'POST',
            headers: Header,
            body: formdata,
        };

        return fetch("https://npln.ir/api/v1/user/token", requestOptions)
            .then(response => response.json())
            .then(res => {
                 console.log(res);

                const data = res
                dispatch({ type: SET_PUSH_TOK, data });
                return res;
            })

            .catch(error => console.log('error', error));
    };
}









export const sendOtp = async (task) => {
    const Header = {
        Accept: "application/json",
    }
    var formdata = new FormData();
    formdata.append("mobile", task);

    var requestOptions = {
        method: 'POST',
        headers: Header,
        body: formdata,
    };

    fetch("https://npln.ir/api/v1/auth/send-sms", requestOptions)
        .then(response => response.json())
        .then(result => console.log(result))
        .catch(error => console.log('error', error));
};



export const login = (task, otp) => {
    return async (dispatch) => {
        const Header = {

            Accept: "application/json",
        }

        var formdata = new FormData();
        formdata.append("mobile", task);
        formdata.append("code", otp);

        var requestOptions = {
            method: 'POST',
            headers: Header,
            body: formdata,
        };

        return fetch("https://npln.ir/api/v1/auth/login", requestOptions)
            .then(response => response.json())
            .then(res => {
                 console.log(res);

                const data = res
                dispatch({ type: LOGIN, data });
                return res;
            })

            .catch(error => console.log('error', error));
    };
}



export const getState = (access_token) => {
    return async (dispatch) => {
        const url = "https://npln.ir/api/v1/app/state";
        let Header = {
            Accept: "application/json",
            Authorization: "Bearer " + access_token,
        };

        return axios({
            method: "get",
            url: url,
            headers: Header,
        })

            .then(function (response) {
                //console.log(response);
                const resData = response;
                const data = resData.data;
                //console.log(data);
                dispatch({ type: STATE, data });
                return response;
            })
            .catch(function (error) {
                console.log(error.name);
                console.log(error.message);
                console.log(error);
            });
    };
};




export const getCity = (access_token, ids) => {
    return async (dispatch) => {

        let Header = {
            Accept: "application/json",
            Authorization: "Bearer " + access_token,
        };
        const url = "https://npln.ir/api/v1/app/city?state_id=" + ids;
        return axios({
            method: "get",
            url: url,
            headers: Header,
        })

            .then(function (response) {
                //console.log(response);
                const resData = response;
                const data = resData.data;
                //console.log(data);
                dispatch({ type: CITY, data });
                return response;
            })
            .catch(function (error) {
                console.log(error.name);
                console.log(error.message);
                console.log(error);
            });
    };
};






export const SetConfig = (access_token, state, city) => {

    let Header = {
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
    };
    var formdata = new FormData();
    formdata.append("state_id", state);
    formdata.append("city_id", city);

    var requestOptions = {

        method: 'POST',
        headers: Header,
        body: formdata,
    };

    fetch("https://npln.ir/api/v1/user/state-city", requestOptions)
        .then(response => response.json())
        .then(res => {
            // console.log(res);
            return res;
        })

        .catch(error => console.log('error', error));
};



export const getProfileinfo = (access_token) => {
    return async (dispatch) => {

        let Header = {
            Accept: "application/json",
            Authorization: "Bearer " + access_token,
        };
        const url = "https://npln.ir/api/v1/app/all-config";
        return axios({
            method: "get",
            url: url,
            headers: Header,
        })

            .then(function (response) {
                //console.log(response);
                const resData = response;
                const data = resData.data;
               //console.log(data);
                dispatch({ type: PROFILE_INFO, data });
                return response;
            })
            .catch(function (error) {
                console.log(error.name);
                console.log(error.message);
                console.log(error);
                
            });
    };
};



export const sendprofile = (access_token, name, family, job, state, city) => {
    return async (dispatch) => {
        let Header = {
            Accept: "application/json",
            Authorization: "Bearer " + access_token,
        };
        var formdata = new FormData();
        formdata.append("first_name", name);
        formdata.append("last_name", family);
        formdata.append("job", job);
        formdata.append("state_id", state);
        formdata.append("city_id", city);



        var requestOptions = {

            method: 'POST',
            headers: Header,
            body: formdata,
        };

        return fetch("https://npln.ir/api/v1/user/edit", requestOptions)
            .then(response => response.json())
            .then(res => {
                //console.log(res);
                const data = res
                dispatch({ type: SET_PROFILE, data });
                return res;
            })

            .catch(error => console.log('error', error));
    };
}


export const getSlider = (access_token) => {
    return async (dispatch) => {

        let Header = {
            Accept: "application/json",
            Authorization: "Bearer " + access_token,
        };
        const url = "https://npln.ir/api/v1/app/slider";
        return axios({
            method: "get",
            url: url,
            headers: Header,
            
        })

            .then(function (response) {
                //console.log(response);
                const resData = response;
                const data = resData.data;
                //console.log(data);
                dispatch({ type: GET_SLIDER, data });
                return response;
            })
            .catch(function (error) {
                console.log(error.name);
                console.log(error.message);
                console.log(error);



            });
    };
};



export const getApp = (access_token) => {
    return async (dispatch) => {

        let Header = {
            Accept: "application/json",
            Authorization: "Bearer " + access_token,
        };
        const url = "https://npln.ir/api/v1/app/app";
        return axios({
            method: "get",
            url: url,
            headers: Header,
        })

            .then(function (response) {
                //console.log(response);
                const resData = response;
                const data = resData.data;
                //console.log(data);
                dispatch({ type: GET_APP, data });
                return response;
            })
            .catch(function (error) {
                console.log(error.name);
                console.log(error.message);
                console.log(error);
            });
    };
};



export const AddTicket = (access_token, task, otp) => {
    return async (dispatch) => {
        let Header = {
            Accept: "application/json",
            Authorization: "Bearer " + access_token,
        };

        var formdata = new FormData();
        formdata.append("type", "text");
        formdata.append("title", task);
        formdata.append("msg", otp);

        var requestOptions = {
            method: 'POST',
            headers: Header,
            body: formdata,
        };

        return fetch("https://npln.ir/api/v1/app/ticket/add", requestOptions)
            .then(response => response.json())
            .then(res => {
                //  console.log(res);
                const data = res
                dispatch({ type: ADD_TICKET, data });
                return res;
            })

            .catch(error => console.log('error', error));
    };

}


export const getTicket = (access_token, offset) => {
    return async (dispatch) => {

        let Header = {
            Accept: "application/json",
            Authorization: "Bearer " + access_token,
        };
        const url = "https://npln.ir/api/v1/app/ticket/tickets?page=" + offset;
        return axios({
            method: "get",
            url: url,
            headers: Header,
        })

            .then(function (response) {
                //console.log(response);
                const resData = response;
                const data = resData.data;
                //console.log(data);
                dispatch({ type: GET_TICKET, data });
                return response;
            })
            .catch(function (error) {
                console.log(error.name);
                console.log(error.message);
                console.log(error);
            });
    };
};



export const walletcharge = (access_token, ids) => {
    return async (dispatch) => {

        let Header = {
            Accept: "application/json",
            Authorization: "Bearer " + access_token,
        };
        const url = "https://npln.ir/api/v1/app/verify-marketer?code=" + ids;
        return axios({
            method: "get",
            url: url,
            headers: Header,
        })

            .then(function (response) {
                //console.log(response);
                const resData = response;
                const data = resData.data;
                //console.log(data);
                dispatch({ type: GET_WALLET, data });
                return response;
            })
            .catch(function (error) {
                console.log(error.name);
                console.log(error.message);
                console.log(error);
            });
    };
};



